module.exports = __webpack_public_path__ + "img/classics3_8ko.1ab1d14.jpg";